<script>
  import { tempStore } from "../../stores/temp.store";
  import { hooksStore } from "../../stores/hooks.store";

  import { config } from "./config";

  import { vratRozkopavkaGeojsonData } from "../../api/rozkopavky";
  import {
    zobrazRozkopavky,
    nastavVsetkyVrstvy,
    upravFeaturesDesc,
    zrusit,
  } from "./rozkopavky.func";
  import Formular from "./Formular.svelte";

  import { viditelnostTabu } from "../Base/sidebarLeft.func";
  import VrstvySub from "../Base/sidebar/VrstvySub.svelte";

  import Icon from "../../components/Icon/Icon.svelte";

  import { get as get_store } from "svelte/store";

  import set from "set-value";
  import get from "get-value";

  const kodMenu = config.moduleName;
  let open = false;
  let formularIsOpen = false;
  let rozkopavkaId;
  let sourceId;

  let filtre = [
    {
      name: "Základné delenie",
      internal_name: "zakladne",
      input_type: "checkbox",
      order: 1,
      parent_id: null,
      expanded: true,
      vsetkyVrstvy: (e) => nastavVsetkyVrstvy(e),
      legenda: [],
      childNodes: [
        {
          name: "Aktívne",
          internal_name: "aktivne",
          input_type: "radio",
          order: 1,
          type: "radio",
          parent_id: null,
          childNodes: [],
          checked: false,
          onChange: () => zobrazRozkopavky(),
          legenda: [
            { html_kod: "8700ff", text: "Bez dátumu konca záruky" }, // rozkopavka
            { html_kod: "20e852", text: "V záruke (>6m)" }, // v zaruke
            { html_kod: "ffbf00", text: "Končiaca záruka (<6m)" }, // konci zaruka
            { html_kod: "ff0000", text: "Skončila záruka" }, // skoncila zaruka
          ],
        },
        {
          name: "Končiaca záruka (< 6m)",
          internal_name: "konciaca_zaruka",
          input_type: "radio",
          order: 2,
          type: "radio",
          parent_id: null,
          childNodes: [],
          checked: false,
          onChange: () => zobrazRozkopavky(),
          legenda: [
            { html_kod: "ffbf00", text: "Končiaca záruka (<6m)" }, // konci zaruka
          ],
        },
        {
          name: "Zmazané",
          internal_name: "zmazane",
          input_type: "radio",
          order: 3,
          type: "radio",
          parent_id: null,
          childNodes: [],
          checked: false,
          onChange: () => zobrazRozkopavky(),
          legenda: [
            { html_kod: "000000", text: "Zmazaná" }, // deleted_at
          ],
        },
      ],
    },
  ];

  hooksStore.addFilter(
    "source_id",
    config.mainFileName,
    (source_id, typ, id) => {
      if (typ === config.type) {
        return `${typ}_${id}`;
      }

      return source_id;
    }
  );

  hooksStore.addFilter(
    "zobrazDataNaMape_vratGeojsonData",
    config.mainFileName,
    async (sourceData, typ, id) => {
      if (typ === config.type) {
        let geojson;
        const data = await vratRozkopavkaGeojsonData(config.type, id);
        if (get(data, "0")) {
          geojson = data[0];
        }
        return geojson;
      }

      return sourceData;
    }
  );

  hooksStore.addFilter(
    "zobrazDataNaMape_upravSourceData",
    config.mainFileName,
    (sourceData, typ, id) => {
      if (typ === config.type) {
        return upravFeaturesDesc(sourceData);
      }

      return sourceData;
    }
  );

  hooksStore.addFilter(
    "tableItemPoi_zrusHover",
    config.mainFileName,
    (response, typ, id) => {
      if (typ === config.type) {
        return true;
      }

      return false;
    }
  );

  hooksStore.addFilter(
    "sidebarLeft_viditelnostTabu_doCustom",
    config.mainFileName,
    (excludes, typ, menu) => {
      if (typ === config.type || menu === config.type) {
        excludes.push(config.type);
      }
      return excludes;
    }
  );

  hooksStore.addAction(
    "sidebarLeft_viditelnostTabu",
    config.mainFileName,
    (menu, typ) => {
      let store = get_store(tempStore);
      if ((typ === config.type || menu === config.type) && formularIsOpen) {
        hooksStore.doAction("confirmDialog", {
          texts: {
            title: config.texts.dialog.title,
            text: config.texts.dialog.text,
            confirm: config.texts.dialog.confirm,
            cancel: config.texts.dialog.cancel,
          },
          callback: () => {
            zrusit(sourceId, rozkopavkaId);
            set(store, "menu", null);
            tempStore.set(store);
          },
        });
      } else if (
        (typ === config.type || menu === config.type) &&
        !formularIsOpen
      ) {
        set(store, "menu", menu === typ ? null : typ);
        tempStore.set(store);
      }
    }
  );

  const unsubscribe = tempStore.subscribe((value) => {
    viditelnostMenu(value);
  });

  function viditelnostMenu(value) {
    let menu = get(value, "menu");
    open = kodMenu === menu;
  }
</script>

<!-- Tab change map start -->
<div
  class="sidebar__tab sidebar__tab--{config.moduleName} sidebar__tab--siroky"
  class:js-tab--open={open}
  data-tab="2"
  id="tab{config.moduleNameCamelCase}"
>
  <div
    class="sidebar__close"
    on:click|preventDefault={() => viditelnostTabu(kodMenu)}
  >
    <Icon kod="012" />
  </div>
  <div class="sidebar__wrapper">
    <h6 class="sidebar__heading">{config.texts.title}</h6>

    <nav class="accordion arrows filtre">
      <!-- <VrstvySub expanded vrstvy={$configStore.vrstvy} /> -->
      {#each filtre as vrstva}
        <VrstvySub
          name={vrstva.name}
          childNodes={vrstva.childNodes && vrstva.childNodes.length
            ? vrstva.childNodes
            : []}
          input_type={vrstva.input_type}
          onChange={vrstva.onChange}
          expanded={vrstva.expanded}
          vsetkyVrstvy={vrstva.vsetkyVrstvy}
          legenda={vrstva.legenda}
        />
      {/each}
    </nav>

    <Formular {kodMenu} bind:formularIsOpen bind:rozkopavkaId bind:sourceId />
  </div>
</div>

<style>
  .sidebar__tab--siroky {
    width: 470px;
  }
  .accordion {
    max-width: none;
    margin-bottom: 50px;
  }
</style>
